<b-modal v-model="modal_requirement_047" :size="modalSize" :header-bg-variant="headerColor" header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking :hide-footer="phase === 'writing'">
  <template v-slot:header>
    <div class="text-center w-100">
      <!-- 実行中 -->
      <template v-if="phase === 'standby'">
        {{ $t('individual.common_title_execution') }}
      </template>
      <!-- 確認 -->
      <template v-if="phase === 'start' ||phase === 'delChk'">
        {{ $t('message.common_title_confirmation') }}
      </template>
      <!-- 成功 -->
      <template v-if="phase === 'success'">
        {{ $t('message.common_title_success') }}
      </template>
      <!-- エラー -->
      <template v-if="phase === 'notExist' || phase === 'writeFailed' || phase === 'failed'">
        {{ $t('message.common_title_error') }}
      </template>
    </div>
  </template>
  <template v-slot:default>
    <ShowLessBOverlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid" style="min-height: 140px;">
        <!-- 書込一覧確認 -->
        <template v-if="phase === 'start'">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="col-12 text-left">
                <div class="row">
                  <div class="box-margin-right work-support-message"
                    v-html="$t(`individual.label_work_support_filter`)"></div>
                  <div class="col-12 d-flex mt-2">
                    <div class="d-flex w-100" style="align-items: self-end;">
                      <!-- 登録日（年）-->
                      <div class="w-24 mr-2">
                        <b-form-group class="form-group">
                          <label class="filter_label">{{ $t(`${i18nWsKey}.label_filter_registered_year`) }}</label>
                          <b-form-select v-model="selectedYear" :options="searchYearOptions" @change="searchFilter()" class="custom-select" />
                        </b-form-group>
                      </div>
                      <!-- （月）-->
                      <div class="w-24 mr-2">
                        <b-form-group class="form-group">
                          <label class="filter_label">{{ $t(`${i18nWsKey}.label_filter_registered_month`) }}</label>
                          <b-form-select v-model="selectedMonth" :options="searchMonthOptions"
                            @change="searchFilter()" class="custom-select"/>
                        </b-form-group>
                      </div>
                      <!-- 登録者 -->
                      <div class="w-18 mr-2">
                        <b-form-group class="form-group">
                          <label class="filter_label">{{ $t(`${i18nWsKey}.label_registrant`) }}</label>
                          <b-form-input v-model="filterRegistrant" type="text" id="filter-registrant-012"
                            @input="searchFilter" />
                        </b-form-group>
                      </div>
                      <!-- DataID -->
                      <div class="w-18 mr-2">
                        <b-form-group class="form-group">
                          <label class="filter_label">{{ $t(`${i18nWsKey}.label_data_id`) }}</label>
                          <b-form-input v-model="filterDataId" type="text" id="filter-data-id-012" @input="searchFilter" />
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </div>
                <custom-table useStripeStyle useSort currentSortkey="registered_at" initSortDir="desc" rowSelect hasTabs
                  :items="filteredDataList" :columns="systemTableColumns" class="support-table mt-2" type="simple"
                  @rowClicked="clickRow" @rowButtonClicked="deleteRow" usePopup>
                  <template v-slot:rowButton>
                    {{ $t(`${i18nWsKey}.label_data_delete`) }}
                  </template>
                </custom-table>
                <b-container fluid>
                  <b-row>
                    <b-col sm="2" class="b-col-title">
                      <div class="box-margin-right work-support-message">{{ $t(`${i18nWsKey}.label_read_data`)
                        }}</div>
                    </b-col>
                    <b-col sm="10">
                      <b-form-textarea type="text" :value="dataIdReadData" class="mt-3 work-support-textarea" readonly
                        size="sm" rows="7" autocomplete="off">
                      </b-form-textarea>
                    </b-col>
                  </b-row>
                </b-container>
              </div>
              <div class="text-left align-middle">
                <div class="box-margin-right work-support-message">{{ $t(`${i18nWsKey}.label_write_confirm`) }}</div>
              </div>
            </div>
          </div>
        </template>
        <!-- 削除確認 -->
        <template v-if="phase === 'delChk'">
          <div class="w-100">
            <div class="text-left align-middle">
              <div class="box-margin-right work-support-message">{{ $t(`${i18nWsKey}.label_delete_message`) }}</div>
            </div>
          </div>
        </template>
        <!-- 削除済み -->
        <template v-if="phase === 'notExist'">
          <div class="w-100">
            <div class="text-left align-middle">
              <div class="box-margin-right work-support-message">{{ $t(`${i18nWsKey}.label_data_deleted`) }}</div>
            </div>
          </div>
        </template>
        <!-- 登録成功 -->
        <template v-if="phase === 'success'">
          <div class="w-100">
            <div class="text-left align-middle">
              <div class="box-margin-right work-support-message">{{ $t(`${i18nWsKey}.label_write_success`) }}</div>
            </div>
          </div>
        </template>
        <!-- 書込失敗 -->
        <template v-if="phase === 'writeFailed'">
          <div class="w-100">
            <div class="box-margin-right work-support-message" style="white-space: break-spaces;">{{
              $t(`${i18nWsKey}.label_write_failed`) }}</div>
          </div>
        </template>
        <!-- 共通エラー -->
        <template v-if="phase === 'failed'">
          <div class="w-100">
            <div class="box-margin-right work-support-message" style="white-space: break-spaces;"
              v-html="$t(`individual.error_communication_error`)"></div>
          </div>
        </template>
      </div>
    </ShowLessBOverlay>
  </template>

  <template v-slot:footer>
    <div class="w-100 text-center ">
      <!-- 書込一覧確認 -->
      <template v-if="phase === 'start'">
        <b-button size="sm" :disabled="isLoading" variant="outline-primary" @click="closeWizard" class="mx-2">
          {{ $t('message.common_button_cancel') }}
        </b-button>
        <b-button size="sm" :disabled="isLoading || !selectedDestination" variant="primary" @click="read" class="mx-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
      <!-- 削除確認 -->
      <template v-if="phase === 'delChk'">
        <b-button size="sm" :disabled="isLoading" variant="outline-primary" @click="delCancel" class="mx-2">
          {{ $t('message.common_button_cancel') }}
        </b-button>
        <b-button size="sm" :disabled="isLoading" variant="primary" @click="delOk" class="mx-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
      <!-- 削除済みエラー -->
      <template v-if="phase === 'notExist'">
        <b-button size="sm" variant="primary" @click="closeWizard" class="mx-2" :disabled="isLoading">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
      <!-- 書込失敗 -->
      <template v-if="phase === 'writeFailed'">
        <b-button size="sm" :disabled="isLoading" variant="primary" @click="write" class="mx-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
      <!-- 登録成功, 共通エラー -->
      <template v-if="phase === 'success' || phase === 'failed'">
        <b-button size="sm" variant="primary" @click="exit" class="mx-2" :disabled="isLoading">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
    </div>
  </template>
</b-modal>